var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.33333V4H5.34868V5.33333H12.5333H13.3333ZM5.33334 7.33333H13.3333V8.66667H5.33334V7.33333ZM5.33334 10.6667H13.3333V12H5.33334V10.6667Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 4H2.66666V5.33333H3.99999V4Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 7.33333H2.66666V8.66667H3.99999V7.33333Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 10.6667H2.66666V12H3.99999V10.6667Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxList);
export default __webpack_public_path__ + "static/media/bx-list.cade850ee258870a507417d2ef0f9e88.svg";
export { ForwardRef as ReactComponent };